import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getReportsSelector, cleanupImsReceiptsData, clearPreSignedUrls } from '../../../../../../../../redux/reducers/reducerSlices/ReportsReducerSlice';
import ImsReceiptsTable from '../Children/ImsReceiptsTable/ImsReceiptsTable';
import './IMSReceiptsWrapper.css';
import ImsReceiptSearch from '../Children/ImsReceiptSearch/ImsReceiptSearch';
import SendEmailSS from '../../../../../../sendEmailSS';
import Popup from '../../../../../../Common/Popup/Popup';
import { AppConstant } from '../../../../../../../Assests/AppConstant';
import { sagaActions } from '../../../../../../../../sagas/sagaActions';
import { showAlert } from '../../../../../../../Assests/Utility';
import { toast } from 'react-toastify';
import { getFsWarehouseselector } from '../../../../../../../../redux/reducers/reducerSlices/FsWarehouseReducer';

const IMSReceiptsWrapper = (props) => {
    const dispatch = useDispatch();
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [downloading, setDownloading] = useState(null);
    const [warehouseList, setWarehouseList] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const { initateLoading, error, imsReceiptsData, operationObj } = useSelector(getReportsSelector);
    const fsWarehouseReducer = useSelector(getFsWarehouseselector);
    const { fsPayWarehouseData, isLoading: warehouseLoading } = fsWarehouseReducer;

    useEffect(() => {
        // Cleanup action when the component unmounts
        dispatch(cleanupImsReceiptsData());
        // Fetch warehouse list on component mount
        fetchWarehouseList();
        return () => {
            dispatch(cleanupImsReceiptsData());
        };
    }, []);

    /**
     * Fetch warehouse list using getWarehouseSpecificDetails API with type:"ALDI"
     */
    const fetchWarehouseList = () => {
        const operationObj = {
            type: 'Fetch Warehouse',
            status: ''
        };

        const params = {
            "currentPage": 1,
            "itemsPerPage": 1000,
            "searchParam": "",
            "crudType": 'S'
        };

        dispatch({ type: sagaActions.GET_FS_PAY_WAREHOUSE_DETAILS, payload: params, operationObj: operationObj });
    };

    /**
     * Update warehouse list when data is received - filter for ALDI prefix
     */
    useEffect(() => {
        if (fsPayWarehouseData && fsPayWarehouseData?.data?.Items?.length) {
            // Filter warehouses that contain "ALDI" in their name or relay site ID
            const aldiWarehouses = fsPayWarehouseData.data.Items.filter(warehouse =>
                warehouse.warehouseName?.toUpperCase().includes('ALDI') ||
                warehouse.relaysiteId?.toUpperCase().includes('ALDI')
            );
            setWarehouseList(aldiWarehouses);
        } else {
            setWarehouseList([]);
        }
    }, [fsPayWarehouseData?.data?.Items]);

    useEffect(() => {
        if (operationObj?.type) {
            switch (operationObj?.type) {
                case 'receipt':
                    setShowEmailModal(false)
                    showAlert(operationObj?.response?.statusCode === 200 ? toast.TYPE.SUCCESS : toast.TYPE.ERROR, operationObj?.response?.message || 'Unable to send email, try again later', 'light')
                    dispatch({ type: sagaActions.UPDATE_REPORT_OPERATION_OBJECT, payload: {} })
                    break;
                default:
                    break;
            }
        }
    }, [operationObj])

    useEffect(() => {
        if (error & downloading) {
            setDownloading(null);
            dispatch({ type: sagaActions.CLEAR_REPORT_ERROR_OBJECT })
        }
        if (error) {
            if (downloading) {
                showAlert(toast.TYPE.ERROR, `Something went wrong while downloading the images. Please try again later or check your network connection.`, 'light')
                setDownloading(null);
            } else {
                showAlert(toast.TYPE.ERROR, error?.message || AppConstant.notifications.login.wentWrong, 'light')
            }
            dispatch({ type: sagaActions.CLEAR_REPORT_ERROR_OBJECT })
        }
    }, [error])

    const openSendEmail = () => {
        return <SendEmailSS closeSendMailpopup={() => setShowEmailModal(false)} poDetails={imsReceiptsData} type='receipt' appType={props.appType}></SendEmailSS>
    }
 //
    const showSendEmailPopup = () => {
        const popupObj = {
            id: 'sendReceipt',
            modalLabel: 'sendReceiptUser',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: 'Send Email',
            bodyText: openSendEmail(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.comments.cancelCommentButtonTitle
                },
                btn2: {
                    show: true,
                    text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={() => setShowEmailModal(false)} themeSelected={props.themeSelected} showModal={showEmailModal} />
    }

    return (
        <div className='ims-receipts-wrapper'>
            <ImsReceiptSearch
                {...props}
                warehouseList={warehouseList}
                selectedWarehouse={selectedWarehouse}
                setSelectedWarehouse={setSelectedWarehouse}
            />
            {imsReceiptsData && (
                <ImsReceiptsTable data={imsReceiptsData} initateLoading={initateLoading} themeSelected={props.themeSelected} error={error} setShowEmailModal={setShowEmailModal} downloading={downloading} setDownloading={setDownloading} appType={props.appType} />
            )}
            {showSendEmailPopup()}
        </div>
    );
};

export default IMSReceiptsWrapper;
